import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  public readonly lastPostponedTitle$: Observable<string>;
  private readonly _lastPostponedTitle = new Subject<string>();

  constructor(
    protected _titleService: Title,
  ) {
    this.lastPostponedTitle$ = this._lastPostponedTitle.asObservable();
  }

  public setTitle(newTitle: string, isPostponed: boolean): void {
    this._titleService.setTitle(newTitle);
    if (isPostponed) {
      this._lastPostponedTitle.next(newTitle);
    }
  }
}
